<template>
    <DataTable
        class="card"
        :header="header"
        :items="items"
        :fields="fields"
        :loading="loading"
        :error="error"
        :total-rows="offers.max"
    >
        <template #cell(name)="data">
            <b-link :to="createItemUrl(data.item)">
                {{ data.item.name }}
            </b-link>
        </template>
    </DataTable>
</template>



<script>
    import DataTable from '@/components/common/DataTable.vue';

    export default {
        name: 'Offers',
        components: {
            DataTable,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        props: {
            pluginOffers: {
                type: String,
                required: true,
                validator: val => ['in', 'notIn'].includes(val),
            },
        },
        data() {
            return {
                request: this.parentComponent.requestOffers,
                id: this.parentComponent.id,
            };
        },
        computed: {
            fields() {
                return [
                    { key: 'id', label: this.$t('id') },
                    { key: 'name', label: this.$t('name') },
                    { key: 'campaign', label: this.$t('campaign') },
                    { key: 'date', label: this.$t('updatedAt'), formatter: value => value && this.$format.datetime(value) },
                    { key: 'price', label: this.$t('price'), formatter: value => this.$format.currency(value), tdClass: 'nowrap' },
                ];
            },
            header() {
                if (this.pluginOffers === 'in') return this.$t('offersDisplayedOnTheManufacturerSWebsite');
                if (this.pluginOffers === 'notIn') return this.$t('offersNotDisplayedOnTheManufacturerSWebsite');
                return this.$t('offers');
            },
            loading() {
                return this.request.getLoading(this.pluginOffers);
            },
            error() {
                return this.request.getError(this.pluginOffers);
            },
            offers() {
                return this.request.getData(this.pluginOffers) || {};
            },
            items() {
                return this.offers?.items || [];
            },
        },
        methods: {
            fetchOffers() {
                return this.request
                    .id(this.pluginOffers)
                    .get({ urlParams: { id: this.id }, requestParams: { pluginOffers: this.pluginOffers } })
                    .catch(() => {});
            },
            createItemUrl(item) {
                return {
                    name: 'OffersDetails',
                    params: { id: item.id, parentUrl: this.$route.fullPath },
                    query: {},
                };
            },
        },
        created() {
            this.fetchOffers();
        },
    };
</script>
